import { Tag } from 'antd'

import type { AgeingBucket, StockStatus } from '@/features/inventory/ageingApi'

// Colours match the spec — green for fresh, increasing red for old.
const BUCKET_COLOR: Record<AgeingBucket, string> = {
  '0-30':     'green',
  '31-60':    'lime',
  '61-90':    'gold',
  '91-180':   'orange',
  '181-365':  'volcano',
  '365+':     'red',
}

const STATUS_COLOR: Record<StockStatus, string> = {
  FRESH:                    'green',
  SLOW_MOVING:              'gold',
  DEAD_STOCK:               'red',
  CRITICAL_RESERVED_STOCK:  'purple',
}

interface Props {
  bucket?: AgeingBucket | null
  status?: StockStatus | null
}

export default function AgeingBucketBadge({ bucket, status }: Props) {
  if (!bucket && !status) return <span style={{ color: '#999' }}>—</span>
  return (
    <>
      {bucket && <Tag color={BUCKET_COLOR[bucket]}>{bucket}d</Tag>}
      {status && <Tag color={STATUS_COLOR[status]}>{status.replace(/_/g, ' ')}</Tag>}
    </>
  )
}
